<template>
  <div>
    <page-header
      :actions="pageHeaderActionsConfig"
      :page="pageHeaderConfig"
      right-side-class="col-sm-12 col-md-4 align-items-end d-flex pb-2 justify-content-end"
    />
    <div v-if="!readOnly">
      <proposal-evaluation-documents
        :proposal-request-id="Number(proposalRequestId)"
        title="Documentos de Propuesta"
      />
      <proposal-evaluation-documents
        v-if="amendmentDocument.length"
        :documents="amendmentDocument"
        title="Documentos de Enmienda"
      />
    </div>
    <validation-observer ref="proposalRequestQuestionnaire">
      <custom-tab v-if="isTodos" class="custom-tabs" @input="onActiveTab">
        <custom-tab-item active lazy title="Educativos">
          <proposal-evaluation
            :key="evaluationFormId"
            :evaluation="proposalRequestQuestionnaire"
            :read-only="readOnly"
            @isTouched="updateTouched"
            @updateAdditionalQuestions="updateAdditionalQuestions"
            @updateAnswers="updateAnswers"
          />
        </custom-tab-item>
        <custom-tab-item lazy title="Relacionados">
          <proposal-evaluation
            :key="evaluationFormId"
            :evaluation="proposalRequestQuestionnaire"
            :read-only="readOnly"
            @isTouched="updateTouched"
            @updateAdditionalQuestions="updateAdditionalQuestions"
            @updateAnswers="updateAnswers"
          />
        </custom-tab-item>
      </custom-tab>
      <custom-tab
        v-else-if="hasRubric"
        class="custom-tabs"
        @input="onActiveRubricTab"
      >
        <custom-tab-item
          v-for="(item, i) in rubrics"
          :key="item.id"
          :active="i == 0"
          lazy
          :title="item.name"
        >
          <rubric-form
            v-model="rubric"
            class="mt-4"
            :is-read-only="readOnly"
            @isTouched="updateTouched"
          />
        </custom-tab-item>
      </custom-tab>

      <proposal-evaluation
        v-else
        :key="evaluationFormId"
        :evaluation="proposalRequestQuestionnaire"
        :read-only="readOnly"
        @updateAdditionalQuestions="updateAdditionalQuestions"
        @updateAnswers="updateAnswers"
      />
    </validation-observer>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import alertMixin from 'utils/mixins/alert.mixin';
import ProposalEvaluation from '@/views/provider/proposalHistory/components/ProposalEvaluation.vue';
import CustomTab from 'custom-tabs/src/CustomTab';
import CustomTabItem from 'custom-tabs/src/CustomTabItem';
import RubricForm from '@/components/common/rubric/form/RubricForm.vue';
import RubricAnswerQuestionTypes from '@/utils/constants/rubricAnswerQuestionTypes';

import {
  getProposalRequestQuestionnaire,
  getProposalServiceTypeEvaluator,
  saveEvaluatorEvaluations,
  getProposalRequest,
  submitProposalEvaluation,
  getAmendmentDocument,
} from '@/modules/serviceProposalHistory/api';

import { getByIdFromAnnouncement } from '@/modules/rubric/api.js';

import evaluationTypes from '@/views/provider/proposalHistory/evaluationTypes';
import evaluationTab from '@/views/provider/proposalHistory/evaluationTab';
import proposalEvaluationStatus from '@/utils/constants/proposalEvaluationStatus';
import tabsId from '@/views/provider/proposalHistory/tabs/tabsId';
import _generalApi from '@/modules/app/api';
import {
  getRubricsEducationalServicesReport,
  getRubricsRelatedServicesReport,
  getRubricReport,
} from '@/modules/serviceProposalHistory/api.js';
import { diff, copy } from '@/utils/objUtils';
import ProposalEvaluationDocuments from '@/views/provider/proposalHistory/components/ProposalEvaluationDocuments.vue';

export default {
  name: 'ServiceProposalEvaluation',
  components: {
    ProposalEvaluationDocuments,
    PageHeader,
    ProposalEvaluation,
    CustomTab,
    CustomTabItem,
    RubricForm,
  },
  mixins: [alertMixin],
  data: () => ({
    answersChanged: false,
    proposalRequestQuestionnaire: {},
    evaluationFormId: null, // Educativo o relacionado,
    proposalEvaluationTypeId: null,
    proposalEvaluationStatusId: null,
    proposalNumber: null,
    academicYearId: null,
    isTodos: false,
    answers: [],
    rubrics: [],
    additionalQuestions: [],
    userId: '',
    readOnly: false,
    rubric: {},
    initialModel: {},
    rubricId: null,
    amendmentDocument: [],
  }),
  computed: {
    pageHeaderConfig() {
      return {
        icon: 'fas fa-user-tie',
        title: 'Formulario de Evaluación de Propuestas',
        routes: ['Proveedor', `Formulario de Evaluación de Propuestas`],
      };
    },
    pageHeaderActionsConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => {
            if (
              (this.proposalRequestQuestionnaire.proposalEvaluationStatusId ==
                proposalEvaluationStatus.EnProcesoEvaluacion ||
                this.proposalRequestQuestionnaire.proposalEvaluationStatusId ==
                  proposalEvaluationStatus.Evaluada) &&
              this.userId == this.$store.state['$_user'].user.profile.sub
            ) {
              this.$router.push({
                name: 'ServiceProposalHistory',
                params: { academicYearId: this.academicYearId },
              });
            } else {
              this.$router.push({
                name: 'ServiceProposalDetails',
                params: {
                  proposalRequestId: this.proposalRequestId,
                  tapIndex: tabsId.Evaluation,
                },
              });
            }
          },
        },
        {
          text: 'Rúbricas',
          icon: 'fas fa-print',
          variant: 'outline-success',
          visible:
            !this.hasRubric &&
            this.evaluationFormId == evaluationTypes.Educativos,
          click: this.printRubricsEducationalServices,
        },
        {
          text: 'Rúbricas',
          icon: 'fas fa-print',
          variant: 'outline-success',
          visible:
            !this.hasRubric &&
            this.evaluationFormId == evaluationTypes.Relacionados,
          click: this.printRubricsRelatedServices,
        },
        {
          text: 'Rúbricas',
          icon: 'fas fa-print',
          variant: 'outline-success',
          visible: this.hasRubric,
          click: this.printRubric,
        },
        {
          text: 'Guardar',
          icon: 'fas fa-save',
          variant: 'outline-success',
          visible: !this.readOnly,
          click: this.saveHandler,
        },
        {
          text: 'Someter',
          icon: 'fas fa-flag-alt',
          variant: 'success',
          click: this.submit,
          visible: !this.readOnly,
        },
      ];
    },
    proposalRequestId() {
      return this.$route.params.proposalRequestId;
    },
    hasRubric() {
      return this.rubrics.length > 0;
    },
  },
  async created() {
    await this.getUser();
  },
  async mounted() {
    await this.initProposalNumber();
    if (!this.hasRubric) {
      await this.getProposalServiceTypeEvaluator();
    }
    this.readOnly =
      this.$route.params.readOnly || Boolean(this.$route.params.userId);
    await this.getProposalQuestionnaire(
      this.proposalRequestId,
      this.evaluationFormId,
      this.userId,
      this.rubricId
    );
    if (this.hasRubric) {
      await this.getRubric();
    }
    await this.getAmendmentDocument();
  },
  methods: {
    async getAmendmentDocument() {
      await getAmendmentDocument(this.proposalRequestId).then(({ data }) => {
        if (data?.documentId != null) {
          this.amendmentDocument.push({
            ...data,
            documentTypeName: 'Documento de Enmienda',
          });
        }
      });
    },
    async getRubric() {
      const { data } = await getByIdFromAnnouncement(
        this.rubricId,
        this.proposalRequestId
      ).catch((e) => this.ShowToast('', e?.response?.data?.message, 'error'));
      const { sections, additionalQuestions } = data;
      const questions = sections.flatMap((s) => s.questions);
      additionalQuestions.forEach((q) => (q.value = null));
      this.updateValues(
        additionalQuestions,
        questions,
        this.proposalRequestQuestionnaire
      );
      this.rubric = data;
      this.initialModel = copy(data);
    },
    async getUser() {
      this.userId =
        this.$route.params.userId ??
        this.$store.state['$_user'].user.profile.sub;
    },
    updateValues(additionalQuestions, questions, evaluation) {
      evaluation.proposalEvaluationSections.forEach((section) => {
        section.questions.forEach((question) => {
          const selectedAnswer = question.answers.find(
            (answer) => answer.isSelected
          );
          if (selectedAnswer) {
            const matchingQuestion = questions.find(
              (q) => q.questionId === question.questionId
            );
            if (matchingQuestion) {
              selectedAnswer.answerId = selectedAnswer.evaluationAnswerId;
              matchingQuestion.value = selectedAnswer;
            }
          }
        });
      });

      evaluation.proposalEvaluationAdditionalQuestionSections.forEach((aq) => {
        const question = additionalQuestions.find(
          (q) => q.id === aq.additionalQuestionId
        );
        if (question) {
          this.setQuestionAnswer(question, aq.answer);
          if (aq.childQuestions?.length) {
            aq.childQuestions.forEach((aqc) => {
              const chidlQuestion = question.childQuestions.find(
                (q) => q.id === aqc.additionalQuestionId
              );
              if (chidlQuestion)
                this.setQuestionAnswer(chidlQuestion, aqc.answer);
            });
          }
        }
      });
    },
    setQuestionAnswer(question, answer) {
      if (!answer) return;
      switch (question.typeId) {
        case RubricAnswerQuestionTypes.SIMPLEHORIZONTAL:
        case RubricAnswerQuestionTypes.SIMPLEVERTICAL:
        case RubricAnswerQuestionTypes.SIMPLEWITHCHILD:
          question.value = question.answers.find((x) => x.name === answer);
          break;
        case RubricAnswerQuestionTypes.MULTIPLEHORIZONTAL:
        case RubricAnswerQuestionTypes.MULTIPLEVERTICAL:
          question.value = question.answers.filter((x) =>
            answer.split(',').includes(x.id.toString())
          );
          break;
        default:
          question.value = answer;
          break;
      }
    },
    async saveHandler(
      message = 'La evaluación ha sido guardada exitosamente.',
      isPartial = true
    ) {
      const { answers, additionalQuestions } = this.hasRubric
        ? this.getRubricAnswersMapped()
        : {
            answers: this.answers,
            additionalQuestions: this.additionalQuestions,
          };
      const saveForm = {
        proposalRequestId: Number(this.proposalRequestId),
        proposalEvaluationTypeId: this.proposalEvaluationTypeId,
        proposalNumber: this.proposalNumber,
        answers,
        additionalQuestions,
        isPartial,
      };

      this.initialModel = copy(this.rubric);

      return saveEvaluatorEvaluations(saveForm)
        .then(async () => {
          if (message) {
            this.ShowToast('Alerta', message, 'success', 5000);
          }

          this.updateTouched(false);
          await this.getProposalQuestionnaire(
            this.proposalRequestId,
            this.evaluationFormId,
            this.userId,
            this.rubricId
          );
        })
        .catch((err) => {
          this.Toast(
            'Alerta',
            err.response.data.message || 'error',
            'error',
            5000
          );
        });
    },
    async printRubricsEducationalServices() {
      await getRubricsEducationalServicesReport().then((response) => {
        _generalApi.ConvertToBlob(response.data);
      });
    },
    async printRubricsRelatedServices() {
      await getRubricsRelatedServicesReport().then((response) => {
        _generalApi.ConvertToBlob(response.data);
      });
    },
    async printRubric() {
      await getRubricReport(this.rubricId).then((response) => {
        _generalApi.ConvertToBlob(response.data);
      });
    },
    async submit() {
      const isValid = await this.$refs.proposalRequestQuestionnaire.validate();
      if (!isValid) {
        this.Toast(
          'Alerta',
          'Favor completar la información para poder continuar.',
          'error'
        );
        return;
      }

      const isAll = this.hasRubric
        ? false
        : this.isTodos === evaluationTypes.Todos;

      this.saveHandler('', false)
        .then(() => submitProposalEvaluation(this.proposalRequestId, isAll))
        .then(() => {
          this.ShowToast(
            'Alerta',
            'La evaluación ha sido sometida exitosamente.',
            'success',
            5000
          );
          this.updateForm();
        })
        .catch((err) => {
          this.Toast(
            'Alerta',
            err.response.data.message || 'error',
            'error',
            5000
          );
        });
    },
    async getProposalServiceTypeEvaluator() {
      await getProposalServiceTypeEvaluator(this.proposalRequestId).then(
        (res) => {
          this.isTodos = Number(res.data) === evaluationTypes.Todos;
          this.evaluationFormId = this.isTodos
            ? evaluationTypes.Educativos
            : Number(res.data);
        }
      );
    },
    async onActiveRubricTab(indexTab) {
      let haveToSave = false;

      const isEditing = diff(this.rubric, this.initialModel, {
        exclude: ['valid', 'expanded', 'score'],
        deep: true,
      });
      if (isEditing) {
        haveToSave = await this.ShowCancelModal(
          'Atención',
          'El sistema encontró que tiene datos sin guardar en esta parte, ¿desea guardar la información antes de continuar?',
          'Si',
          'No'
        );
      }

      if (haveToSave) {
        await this.saveHandler();
      }

      this.rubricId = this.rubrics[indexTab].id;
      this.proposalEvaluationTypeId = this.rubrics[indexTab].evaluationTypeId;
      this.answers = [];
      this.additionalQuestions = [];
      this.updateTouched(false);
      await this.getProposalQuestionnaire(
        this.proposalRequestId,
        this.evaluationFormId,
        this.userId,
        this.rubricId
      );
      await this.getRubric();
    },
    async onActiveTab(indexTab) {
      let haveToSave = false;
      if (this.answersChanged) {
        haveToSave = await this.ShowCancelModal(
          'Atención',
          'El sistema encontró que tiene datos sin guardar en esta parte, ¿desea guardar la información antes de continuar?',
          'Si',
          'No'
        );
      }

      if (haveToSave) {
        await this.saveHandler();
      }

      let evaluationFormId = evaluationTypes.Educativos;

      if (indexTab == evaluationTab.Educativos) {
        evaluationFormId = evaluationTypes.Educativos;
      } else if (indexTab == evaluationTab.Relacionados) {
        evaluationFormId = evaluationTypes.Relacionados;
      }

      this.evaluationFormId = evaluationFormId;

      this.answers = [];
      this.additionalQuestions = [];
      this.updateTouched(false);
      await this.getProposalQuestionnaire(
        this.proposalRequestId,
        this.evaluationFormId,
        this.userId,
        this.rubricId
      );
    },
    async getProposalQuestionnaire(
      proposalRequestId,
      proposalServiceTypeEvaluatorId,
      userId,
      rubricId
    ) {
      this.proposalRequestQuestionnaire = {};
      await getProposalRequestQuestionnaire(
        proposalRequestId,
        proposalServiceTypeEvaluatorId,
        userId,
        rubricId
      )
        .then((res) => {
          if (
            res.data.proposalEvaluationStatusId ===
              proposalEvaluationStatus.Evaluada ||
            res.data.proposalEvaluationStatusId ===
              proposalEvaluationStatus.Anulada
          ) {
            this.readOnly = true;
          }
          this.proposalRequestQuestionnaire = { ...res.data };

          this.proposalEvaluationTypeId = this.hasRubric
            ? this.proposalEvaluationTypeId
            : this.proposalRequestQuestionnaire.proposalEvaluationTypeId;
        })
        .catch((err) => {
          this.Toast(
            'Alerta',
            err.response.data.message || 'error',
            'error',
            5000
          );
        });
    },
    updateTouched(value) {
      this.answersChanged = value;
    },
    updateAnswers(answers) {
      this.answers = [...answers];
    },
    updateForm() {
      this.readOnly = true;
    },
    updateAdditionalQuestions(additionalQuestions) {
      this.additionalQuestions = [...additionalQuestions];
    },
    async initProposalNumber() {
      await getProposalRequest(this.proposalRequestId)
        .then((res) => {
          this.proposalNumber = res.data.proposalNumber;
          this.academicYearId = res.data.academicYearId;
          this.rubrics = res.data.rubrics;
          this.rubricId = this.rubrics[0]?.id ?? null;
          this.proposalEvaluationTypeId =
            this.rubrics[0]?.evaluationTypeId ?? null;
        })
        .catch(() => {
          this.proposalNumber = null;
          this.academicYearId = null;
        });
    },
    getRubricAnswersMapped() {
      const answers = this.rubric.sections
        .flatMap((s) => s.questions)
        .filter((q) => q.value)
        .map(({ id, value: answer }) => ({
          answerTypeId: 1, //Esto es para adaptar el metodo de SaveProposalEvaluationForm
          answerId: answer.answerId, //Esto es para adaptar el metodo de SaveProposalEvaluationForm
          questionId: id,
          answerQuestionId: answer.answerQuestionId,
          answerQuestionValue: answer.value,
        }));
      const questionsAnswers = this.rubric.additionalQuestions
        .filter((c) => c.value)
        .map(({ id, value: answer }) => ({
          sectionId: 0, //Esto es para adaptar el metodo de SaveProposalEvaluationForm
          questionTypeId: 1, //Esto es para adaptar el metodo de SaveProposalEvaluationForm
          questionId: id,
          additionalQuestionId: id,
          answer: Array.isArray(answer)
            ? answer.map((x) => x.id).join(',')
            : (answer.id ? answer.name : answer).toString(),
        }));

      const childQuestionsAnswers = this.rubric.additionalQuestions
        .filter((c) => c.value)
        .flatMap((q) => q.childQuestions.filter((c) => c.value))
        .map(({ id, value: answer }) => ({
          sectionId: 0, //Esto es para adaptar el metodo de SaveProposalEvaluationForm
          questionTypeId: 1, //Esto es para adaptar el metodo de SaveProposalEvaluationForm
          questionId: id,
          additionalQuestionId: id,
          answer: Array.isArray(answer)
            ? answer.map((x) => x.id).join(',')
            : (answer.id ? answer.name : answer).toString(),
        }));
      return {
        answers,
        additionalQuestions: [...questionsAnswers, ...childQuestionsAnswers],
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';

.custom-tabs {
  --nav-link-color: #11291b;
  --tab-active-color: #ff7058;
}
</style>
